import React, { useState } from 'react';
import { i18n } from 'utils/i18n';
import { safeExecute } from 'utils/validation';
import { uuid } from 'utils/dom';
import { THEMES } from 'constants';
import TextField from 'components/Form/TextField';
import proptypes from './PartnerRewardsFieldsPropTypes';

const PartnerRewardsFields = ({ submitFailed, setPartnerMemberNumber }) => {
  const [value, setValue] = useState('');
  const partnerProgramUUID = uuid();

  const handleOnChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    safeExecute(setPartnerMemberNumber, newValue);
  };

  const inputHasError = submitFailed && !value;

  return (
    <>
      <label className='partner-rewards__label'>{i18n('partner_rewards_label')}</label>
      <TextField
        id={`partnerProgram-${partnerProgramUUID}`}
        label={i18n('partner_rewards_program_label')}
        name='partnerRewardsProgram'
        required
        readOnly
      />
      <TextField
        id={`memberId-${partnerProgramUUID}`}
        label={i18n('partner_rewards_member_number_label')}
        name='partnerRewardsProgramMemberId'
        onChange={handleOnChange}
        required='Member Number Required'
        errorTheme={THEMES.LIGHT_BLUE}
        forceError={inputHasError}
      />
    </>
  );
};

PartnerRewardsFields.propTypes = proptypes;

export default PartnerRewardsFields;
